module.exports = __webpack_public_path__ + "static/full01-7b2e8a37a1d423c2db7205326fb113c5.png";